import { $ } from "@/common/Axios";

export default {
  /**
   * 班级
   */
  classRoom: {
    /*
     * 添加
     * batch 批次 (string query )
     * courseTableStatus 是否已排课 (string query )
     * courseTableTemplate 课表模板 (string query )
     * employTeacherId 就业老师id (integer query )
     * endTime 结束时间 (string query )
     * graduatedStatus 是否已毕业 (string query )
     * headerTeacherId 班主任id (integer query )
     * id  (integer query )
     * level 层次 (string query )
     * majorDirection 专业方向 (string query )
     * name 班级名称 (string query )
     * siteId 学校id (integer query )
     * startTime 开始时间 (string query )
     * term 当前学期 (integer query )
     */
    post: (p, c) => $.post("/api/ems/server/classRoom", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/server/classRoom", p, c),
  },
  classRoom_batchUpdateTerm: {
    /*
     * 批量修改当前学期
     * ids 班级id (array query required)
     * term 当前学期 (integer query required)
     */
    put: (p, c) => $.put("/api/ems/server/classRoom/batchUpdateTerm", p, c),
  },
  classRoom_downloadModuleForCont: {
    /*
     * 下载模版(职教学校平台)
     */
    get: (p, c) =>
      $.get("/api/ems/server/classRoom/downloadModuleForCont", p, c),
  },
  classRoom_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/export", p, c),
  },
  classRoom_exportForCont: {
    /*
     * 导出(职教学校平台)
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/exportForCont", p, c),
  },
  classRoom_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/list", p, c),
  },
  classRoom_listAllForCourseTableTemplate: {
    /*
     * 所有班级（排课用）
     * courseTableTemplate 课表模板 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/classRoom/listAllForCourseTableTemplate", p, c),
  },
  classRoom_listForCont: {
    /*
     * 列表(职教学校平台)
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/listForCont", p, c),
  },
  classRoom_listForTeacher: {
    /*
     * 列表（讲师）
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/listForTeacher", p, c),
  },
  classRoom_listSelectIdForCourseTableTemplate: {
    /*
     * 已排课班级id（排课用）
     * courseTableTemplate 课表模板 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/classRoom/listSelectIdForCourseTableTemplate",
        p,
        c
      ),
  },
  classRoom_listSimple: {
    /*
     * 简易列表
     * batch 批次 (string query )
     * employStatus 是否内部员工 (string query )
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/listSimple", p, c),
  },
  classRoom_listSimpleForCont: {
    /*
     * 简易列表(职教学校平台)
     * batch 批次 (string query )
     * majorDirection 学院 (string query )
     */
    get: (p, c) => $.get("/api/ems/server/classRoom/listSimpleForCont", p, c),
  },
  classRoom_listSimpleForHeaderTeacher: {
    /*
     * 班主任所负责班级简易列表
     */
    get: (p, c) =>
      $.get("/api/ems/server/classRoom/listSimpleForHeaderTeacher", p, c),
  },
  classRoom_listSimpleForSubstituteTeacher: {
    /*
     * 代班老师所负责班级简易列表
     */
    get: (p, c) =>
      $.get("/api/ems/server/classRoom/listSimpleForSubstituteTeacher", p, c),
  },
  classRoom_listSimpleForTeacher: {
    /*
     * 简易列表(教师)
     * currentStatus 是否当前，默认全部 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/server/classRoom/listSimpleForTeacher", p, c),
  },
  classRoom_updateCourseTableTemplate: {
    /*
     * 更新课表模板
     * classRoomIds 班级id (array query required)
     * courseTableTemplate 课表模板 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/classRoom/updateCourseTableTemplate", p, c),
  },
  classRoom_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/server/classRoom/upload", p, c),
  },
  classRoom_uploadForCont: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/server/classRoom/uploadForCont", p, c),
  },

  /**
   * 企微联系统计
   */
  contactWechatStatistics_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/server/contactWechatStatistics/export", p, c),
  },
  contactWechatStatistics_exportReplyStatistics: {
    /*
     * 导出回复统计
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     * type 类型：班主任、部门 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/contactWechatStatistics/exportReplyStatistics",
        p,
        c
      ),
  },
  contactWechatStatistics_getContentWhiteList: {
    /*
     * 获取内容白名单
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/contactWechatStatistics/getContentWhiteList",
        p,
        c
      ),
  },
  contactWechatStatistics_getRecords: {
    /*
     * 获取企微统计记录
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/contactWechatStatistics/getRecords", p, c),
  },
  contactWechatStatistics_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/contactWechatStatistics/list", p, c),
  },
  contactWechatStatistics_replyStatistics: {
    /*
     * 获取回复统计
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 时间类型 (string query )
     * type 类型：班主任、部门 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/server/contactWechatStatistics/replyStatistics", p, c),
  },
  contactWechatStatistics_restore: {
    /*
     * 修复企微统计
     * end 结束时间 (string query required)
     * start 开始时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/contactWechatStatistics/restore", p, c),
  },
  contactWechatStatistics_setContentWhiteList: {
    /*
     * 设置内容白名单
     * contentWhiteList 内容白名单 (array query )
     */
    post: (p, c) =>
      $.post(
        "/api/ems/server/contactWechatStatistics/setContentWhiteList",
        p,
        c
      ),
  },

  /**
   * 寄书管理
   */
  mailBook_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/mailBook/list", p, c),
  },
  mailBook_listCourse: {
    /*
     * 书本列表
     * ableStatus 启用禁用 (string query )
     * schoolRollId 合同编号 (integer query required)
     * type 类型: 已寄|未寄 (string query required)
     */
    get: (p, c) => $.get("/api/ems/server/mailBook/listCourse", p, c),
  },
  mailBook_listForDetail: {
    /*
     * 学生详情页面展示的列表
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/mailBook/listForDetail", p, c),
  },
  mailBook_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/server/mailBook/remove", p, c),
  },
  mailBook_save: {
    /*
     * 添加编辑
     * courseIds 选择的书本列表 (array query required)
     * mailNo 快递单号 (string query )
     * name 邮寄名称 (string query required)
     * postTime 邮寄时间 (string query required)
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/server/mailBook/save", p, c),
  },
  mailBook_searchById: {
    /*
     * 书本列表
     * id 行ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/server/mailBook/searchById", p, c),
  },
  mailBook_updateMailNo: {
    /*
     * 编辑快递单号
     * id id (integer query required)
     * mailNo 快递单号 (string query required)
     * name 邮寄名称 (string query required)
     * postTime 邮寄时间 (string query required)
     */
    put: (p, c) => $.put("/api/ems/server/mailBook/updateMailNo", p, c),
  },

  /**
   * 邮寄表
   */
  mailService: {
    /*
     * 添加
     * allCount 总人数 (integer query )
     * deadline 截止时间 (string query )
     * examBatch 寄书批次-自考考期 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * rollGrade 学籍年级 (string query )
     * siteType 学校类型 (string query )
     */
    post: (p, c) => $.post("/api/ems/server/mailService", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/server/mailService", p, c),
  },
  mailService_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/mailService/list", p, c),
  },
  mailService_listForClient: {
    /*
     * C端列表
     */
    get: (p, c) => $.get("/api/ems/server/mailService/listForClient", p, c),
  },
  mailService_listName: {
    /*
     * 名字列表
     */
    get: (p, c) => $.get("/api/ems/server/mailService/listName", p, c),
  },
  mailService_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) => $.get("/api/ems/server/mailService/listSimple", p, c),
  },
  mailService_searchLatestForClient: {
    /*
     * C端查询最后的一次邮寄记录, 取地址用
     */
    get: (p, c) =>
      $.get("/api/ems/server/mailService/searchLatestForClient", p, c),
  },
  mailService_updateDeadline: {
    /*
     * 编辑截止时间
     * deadline 截止时间 (string query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/server/mailService/updateDeadline", p, c),
  },

  /**
   * 邮寄表详情
   */
  mailServiceRecord: {
    /*
     * 添加
     * address 具体地址 (string query )
     * city 市 (string query )
     * district 区 (string query )
     * id  (integer query )
     * mailNo 快递单号 (string query )
     * mailServiceId 邮寄表ID (integer query )
     * phone 手机号 (string query )
     * province 省 (string query )
     * schoolRollId 学籍id (integer query )
     */
    post: (p, c) => $.post("/api/ems/server/mailServiceRecord", p, c),
  },
  mailServiceRecord_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/server/mailServiceRecord/export", p, c),
  },
  mailServiceRecord_exportForService: {
    /*
     * 导出（服务）
     */
    get: (p, c) =>
      $.get("/api/ems/server/mailServiceRecord/exportForService", p, c),
  },
  mailServiceRecord_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/server/mailServiceRecord/list", p, c),
  },
  mailServiceRecord_listForService: {
    /*
     * 列表（服务）
     */
    get: (p, c) =>
      $.get("/api/ems/server/mailServiceRecord/listForService", p, c),
  },
  mailServiceRecord_updateMailNo: {
    /*
     * 编辑快递单号
     * id id (integer query required)
     * mailNo 快递单号 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/mailServiceRecord/updateMailNo", p, c),
  },
  mailServiceRecord_uploadMailNo: {
    /*
     * 导入快递单号
     * excelFile excelFile (file formData required)
     * mailServiceId id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/server/mailServiceRecord/uploadMailNo", p, c),
  },

  /**
   * 服务联系记录(新)
   */
  serviceContactManually: {
    /*
     * 添加
     * attach 附件 (string query )
     * content 联系内容 (string query required)
     * loseRiskLevel 流失风险等级（职教合同用） (string query )
     * preContactTime 预计下次联系时间 (string query )
     * schoolRollId 合同编号 (integer query required)
     * source 来源 (string query required)
     */
    post: (p, c) => $.post("/api/ems/server/serviceContactManually", p, c),
  },
  serviceContactManually_listDailyRecord: {
    /*
     * 联系记录列表-日常手动添加的
     * schoolRollId 合同id (integer query required)
     * source 来源 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceContactManually/listDailyRecord", p, c),
  },
  serviceContactManually_listWechatRecord: {
    /*
     * 联系记录列表-企微的
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceContactManually/listWechatRecord", p, c),
  },

  /**
   * 学历服务信息
   */
  serviceSchoolRoll_assign: {
    /*
     * 分配班主任
     * headerTeacherId 班主任id (integer query required)
     * ids 服务信息id (array query required)
     * message 移交企微时发送给学生的消息 (string query )
     * syncWechat 企微学生是否同步移交 (string query required)
     */
    put: (p, c) => $.put("/api/ems/server/serviceSchoolRoll/assign", p, c),
  },
  serviceSchoolRoll_assignForContinue: {
    /*
     * 分配班主任-继教院
     * headerTeacherId 班主任id (integer query required)
     * ids 服务信息id (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/assignForContinue", p, c),
  },
  serviceSchoolRoll_birthdayToday: {
    /*
     * 当天生日学生数量
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/birthdayToday", p, c),
  },
  serviceSchoolRoll_changeHeaderTeacher: {
    /*
     * 移交班主任
     * headerTeacherId 班主任id (integer query required)
     * message 移交企微时发送给学生的消息 (string query )
     * originHeaderTeacherId 原班主任id (integer query required)
     * syncWechat 企微学生是否同步移交 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/changeHeaderTeacher", p, c),
  },
  serviceSchoolRoll_clearWeComBind: {
    /*
     * 清空企微绑定
     * schoolRollId 学籍ID (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/clearWeComBind", p, c),
  },
  serviceSchoolRoll_countContactByDays: {
    /*
     * 距离上次联系时间天数
     * days 天数 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/countContactByDays", p, c),
  },
  serviceSchoolRoll_countOverdueContact: {
    /*
     * 首次联系逾期学生数量
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/countOverdueContact", p, c),
  },
  serviceSchoolRoll_countUnContact: {
    /*
     * 未联系学生数量
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/countUnContact", p, c),
  },
  serviceSchoolRoll_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/downloadMould", p, c),
  },
  serviceSchoolRoll_exportStudentForExemptionDegree: {
    /*
     * 服务学生列表导出（免试专升本）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/serviceSchoolRoll/exportStudentForExemptionDegree",
        p,
        c
      ),
  },
  serviceSchoolRoll_listSimpleStudent: {
    /*
     * 简单服务学生列表(班主任所带)
     * batch 批次 (string query )
     * classRoomIds 班级id (array query )
     * level 层次 (string query )
     * majorId 专业id (integer query )
     * siteId 学校id (integer query )
     * siteType 学校类型 (string query )
     * statuses 学籍状态 (array query )
     */
    get: (p, c) =>
      $.get("/api/ems/server/serviceSchoolRoll/listSimpleStudent", p, c),
  },
  serviceSchoolRoll_listStudentForExemptionDegree: {
    /*
     * 服务学生列表（免试专升本）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/serviceSchoolRoll/listStudentForExemptionDegree",
        p,
        c
      ),
  },
  serviceSchoolRoll_listUnAssignForExemptionDegree: {
    /*
     * 未分配学生列表(免试专升本)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/server/serviceSchoolRoll/listUnAssignForExemptionDegree",
        p,
        c
      ),
  },
  serviceSchoolRoll_remark: {
    /*
     * 备注
     * id id (integer query required)
     * remark 标签 (string query required)
     */
    put: (p, c) => $.put("/api/ems/server/serviceSchoolRoll/remark", p, c),
  },
  serviceSchoolRoll_sendUnAssignNoticeToAdminTeacher: {
    /*
     * 发送未分配班主任钉钉通知到招生老师
     */
    post: (p, c) =>
      $.post(
        "/api/ems/server/serviceSchoolRoll/sendUnAssignNoticeToAdminTeacher",
        p,
        c
      ),
  },
  serviceSchoolRoll_syncAdultForContinue: {
    /*
     * 同步成教班主任
     * siteId 学校id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/syncAdultForContinue", p, c),
  },
  serviceSchoolRoll_updatePhotoForContinue: {
    /*
     * 更新个人照|高中毕业证书
     * diplomaNo 高中毕业证编号 (string query )
     * diplomaPhoto 高中毕业证 (string query )
     * educationLevel 层次 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationSchool 毕业院校 (string query )
     * graduationTime 毕业时间 (string query )
     * id id (integer query required)
     * photo 个人照 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/updatePhotoForContinue", p, c),
  },
  serviceSchoolRoll_uploadChangeHeaderTeacher: {
    /*
     * 导入更换班主任
     * excelFile excelFile (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/server/serviceSchoolRoll/uploadChangeHeaderTeacher",
        p,
        c
      ),
  },
  serviceSchoolRoll_uploadPhotoForContinue: {
    /*
     * 批量导入个人照|高中毕业证书
     * idCardNo 身份证 (string query required)
     * photo 地址 (string query )
     * type type: 0全部更新 1个人照 2高中毕业证 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/server/serviceSchoolRoll/uploadPhotoForContinue", p, c),
  },

  /**
   * 服务学生统计
   */
  serviceStudentStatistics_autoCountContinueSchoolingStudent: {
    /*
     * 测试-定时任务，每月1号凌晨查询继教院在读人数
     * currentTime 时间 (string query )
     */
    post: (p, c) =>
      $.post(
        "/api/ems/server/serviceStudentStatistics/autoCountContinueSchoolingStudent",
        p,
        c
      ),
  },
  serviceStudentStatistics_repairPeriod: {
    /*
     * 测试-班主任服务周期数据初始化
     */
    post: (p, c) =>
      $.post("/api/ems/server/serviceStudentStatistics/repairPeriod", p, c),
  },
};
